import { useCallback, useEffect, useState } from 'react';

import { VerificationStatus } from './verification-status.enum';

interface UseVerificationStatusProps {
  onVerify: (code: string) => Promise<boolean>;
  successMessageDurationMs: number;
}

export const useVerificationStatus = ({
  onVerify,
  successMessageDurationMs
}: UseVerificationStatusProps) => {
  const [status, setStatus] = useState<VerificationStatus>(VerificationStatus.IDLE);

  useEffect(() => {
    if (status === VerificationStatus.SUCCESS) {
      const timer = setTimeout(() => {
        setStatus(VerificationStatus.IDLE);
      }, successMessageDurationMs);
      return () => clearTimeout(timer);
    }
  }, [status, successMessageDurationMs]);

  const handleVerification = useCallback(async (code: string) => {
    setStatus(VerificationStatus.VERIFYING);
    try {
      const isSuccess = await onVerify(code);
      setStatus(isSuccess ? VerificationStatus.SUCCESS : VerificationStatus.ERROR);
    } catch {
      setStatus(VerificationStatus.ERROR);
    }
  }, [onVerify]);

  const resetStatus = useCallback(() => {
    setStatus(VerificationStatus.IDLE);
  }, []);

  return {
    status,
    handleVerification,
    resetStatus
  };
};

